import type { FieldNamesMarkedBoolean, FieldValues } from 'react-hook-form';

function hasChangedField(value: unknown): boolean {
  return (
    value === true ||
    (typeof value === 'object' && value !== null && Object.values(value).some(hasChangedField))
  );
}

/** Validate and send only edited top-level fields; untouched source values are not new input. */
export function dirtyFieldsPatch<T extends FieldValues>(
  values: T,
  dirtyFields: Partial<Readonly<FieldNamesMarkedBoolean<T>>>,
  editedFields: ReadonlySet<string>,
): Partial<T> {
  return Object.fromEntries(
    Object.entries(values).filter(
      ([key]) => editedFields.has(key) && hasChangedField(Reflect.get(dirtyFields, key)),
    ),
  ) as Partial<T>;
}
